export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      required: false,
    },
  },
  // props:['question', 'answer'],

  // data() {
  //   return {
  //     answer: '',
  //   };
  // },
  methods: {
    setAnswer(answer) {
      // this.answer = answer;
      this.$emit('input', answer);
    },
  },
};
